module.exports = __webpack_public_path__ + "img/event-3.926ba753.jpg";